import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/opacity.css";

interface Props {
  src: string;
  alt: string;
  className?: string;
  /** CSS aspect-ratio, e.g. "4/3", "1/1". Defaults to "3/2". */
  ratio?: string;
}

export const ImageWithPlaceholder = ({
  src,
  alt,
  className,
  ratio = "3/2",
}: Props) => (
  <div
    style={{
      position: "relative",
      width: "100%",
      aspectRatio: ratio,
      background: "#e8e8e8",
      overflow: "hidden",
    }}
    className={className}
  >
    <LazyLoadImage
      src={src}
      alt={alt}
      effect="opacity"
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        objectFit: "cover",
      }}
    />
  </div>
);
